import { TechnographicProductTreeRO } from "@intentsify/dto";
import { useQuery } from "@tanstack/react-query";
import { apiService, Endpoints } from "api";

export const useTechnographicProducts = () => {
  return useQuery(
    [Endpoints.TalTools.BusinessDataAppend.TechnoProductFilters],
    async ({ signal }) => {
      const response = await apiService.get<TechnographicProductTreeRO[]>(
        Endpoints.TalTools.BusinessDataAppend.TechnoProductFilters,
        { signal }
      );
      return response.data;
    }
  );
};
